export default __webpack_public_path__ + "static/media/rare2.83956233.gif";